import { CommunityGlobalSearchResultItem, GlobalSearchScopeIdentifier } from "client/Api/TitleBar/GlobalSearch/globalSearch";
import { ReactElement } from "react";
import { CommunityListItem } from "../../../Items/CommunityListItem";
import { GlobalSearchItem } from "../../../GlobalSearchItem/GlobalSearchItem";
import { generateTrackingId } from "client/Misc/utils";
import { useCommunityNavigationHandler } from "../../../Navigation/useCommunityNavigationHandler";

export type CommunityItemViewProps = {
	item: CommunityGlobalSearchResultItem;
	itemIndex: number;
	itemScope: GlobalSearchScopeIdentifier;
	tabIndex: number;
};

export const CommunityItemView = (props: CommunityItemViewProps): ReactElement => {
	const {
		item,
		itemIndex,
		itemScope,
		tabIndex
	} = props;

	const {
		id,
		name,
		visibility,
		memberCount,
		isCurrentUserMember,
		hitHighlights,
		color
	} = item;

	const openHandler: () => void = useCommunityNavigationHandler({
		id,
		searchResult: item,
		itemScope
	});

	return (
		<GlobalSearchItem
			trackingId={generateTrackingId("community-item", `|${id}`)}
			onClick={openHandler}
		>
			<CommunityListItem
				id={id}
				visibility={visibility}
				isCurrentUserMember={isCurrentUserMember}
				memberCount={memberCount}
				name={name}
				hitHighlights={hitHighlights}
				color={color}
				itemIndex={itemIndex}
				tabIndex={tabIndex}
				onExecute={openHandler}
			/>
		</GlobalSearchItem>
	);
};
CommunityItemView.displayName = "CommunityItemView";
